import { escapeHTML, aspectRatioClassPattern } from './helpers.js';

export function fetchMorePosts(
  postType = 'post',
  perPage = 8,
  offset = 8,
  event
) {
  const button = event.target;
  const grid = document.getElementById(`${postType}-grid`);

  button.disabled = true;
  button.textContent = 'Loading...'; // SHOULD PROBABLY ADD SPINNER CLASS

  fetch(
    `/wp-json/wp/v2/posts?post_type=${postType}&offset=${offset}&per_page=${perPage}&_embed`
  )
    .then((response) => {
      const totalPosts = response.headers.get('X-WP-Total');

      if (parseInt(totalPosts) <= offset) {
        button.style.display = 'none';
      }

      return response.json();
    })
    .then((posts) => {
      posts.forEach((post, i) => {
        console.log(post);
        const item = document.createElement('article');
        item.className = 'masonry-item';

        const categories = post._embedded['wp:term'][0];
        const dataCategories = categories
          .map((term) => `${term.slug}`)
          .join(' ');

        // handle aspect ratios
        const aspectRatioPattern = aspectRatioClassPattern();
        const aspectRatioClass =
          aspectRatioPattern[i % aspectRatioPattern.length];

        const featuredImageUrl =
          post._embedded['wp:featuredmedia'][0].source_url;
        const backgroundImageStyle = `background-image: linear-gradient(to top, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)), url('${featuredImageUrl}');`;

        item.setAttribute('data-category', dataCategories);
        item.classList.add(aspectRatioClass);
        item.setAttribute('style', backgroundImageStyle);

        const client = post._embedded['wp:term'][1]?.[0]?.name || '';

        generatePostTile(post, categories, item, grid, client);

        grid.appendChild(item);
      });

      button.setAttribute('data-offset', offset + perPage);

      button.disabled = false;
      button.textContent = 'Load More';
    })
    .catch((error) => {
      console.error('Error loading posts:', error);
      button.disabled = false;
      button.textContent = 'Load More';
    });
}

// generates the tiles more securely than using .innerHTML
function generatePostTile(post, categories, item, grid, subtitleText) {
  const masonryContent = document.createElement('div');
  masonryContent.className = 'masonry-content';

  if (subtitleText) {
    const subtitle = document.createElement('h4');
    subtitle.className = 'post-title';
    subtitle.textContent = subtitleText;
    masonryContent.appendChild(subtitle);
  }

  const title = document.createElement('h3');
  title.className = 'u--font-weight-bold u--margin-top-10 u--margin-bottom-10';
  title.textContent = post.title.rendered;

  masonryContent.appendChild(title);

  const footer = document.createElement('div');
  footer.className = 'masonry-item--footer';

  const excerptParagraph = document.createElement('p');
  excerptParagraph.className = 'post-excerpt';

  const excerptSpan = document.createElement('span');
  excerptSpan.className = 'post-excerpt--text';
  const excerpt = post.excerpt.rendered || post.content.rendered;
  excerptSpan.textContent = excerpt.replace(/<p>|<\/p>/g, '');

  excerptParagraph.appendChild(excerptSpan);

  const link = document.createElement('a');
  link.href = post.link;

  const arrowIcon = document.createElement('span');
  arrowIcon.className = 'masonry-item--footer--arrow';
  arrowIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"></path>
        </svg>
    `;

  link.appendChild(arrowIcon);
  excerptParagraph.appendChild(link);

  footer.appendChild(excerptParagraph);

  const categoriesDiv = document.createElement('div');
  categoriesDiv.className = 'our-work-categories';

  categories.forEach((category) => {
    const categorySpan = document.createElement('span');
    categorySpan.className = 'our-work-categories--pill';
    categorySpan.textContent = category.name;
    categoriesDiv.appendChild(categorySpan);
  });

  footer.appendChild(categoriesDiv);

  item.appendChild(masonryContent);
  item.appendChild(footer);

  grid.appendChild(item);
}

document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.btn--pagination');

  buttons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const postType = button.getAttribute('data-post-type') || 'post';
      const perPage = button.getAttribute('data-per-page') || 8;
      const offset = button.getAttribute('data-offset') || 8;
      fetchMorePosts(postType, perPage, offset, event);
    });
  });
});
